import React from "react";

import { Button, Divider, Flex, Layout, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import AppSlice from "../../containers/App/reducer";
import { makeSelectUserInfo } from "../../containers/App/selectors";
import { isChinaInstance } from "../../config/appInstance";
import BrandLogo from "../components/BrandLogo";
import UserMenu from "../components/UserMenu";
import LanguageSelector from "../components/LanguageSelector";
import StickyHeader from "../components/StickyHeader";
import DealNotificationsToUsBadge from "../WorkspaceLayout/components/DealNotificationsToUsBadge";

function PublicLayout({ children }: React.PropsWithChildren) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector(makeSelectUserInfo());
  const { t } = useTranslation("translations");

  const handleOpenAuthModal = React.useCallback(() => {
    dispatch(AppSlice.actions.openAuthModal());
  }, [dispatch]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <StickyHeader>
        <Flex align="center" justify="space-between">
          <BrandLogo />

          <Flex align="center" gap={8}>
            {userInfo?.role.userType === "USER" && <DealNotificationsToUsBadge />}
            <Button type="text" onClick={() => navigate("/about")}>
              {t("about")}
            </Button>
            <Divider orientation="vertical" style={{ marginInline: 0 }} />
            {userInfo ? (
              <UserMenu email={userInfo.email} />
            ) : (
              <>
                <LanguageSelector />
                <Button type="primary" onClick={handleOpenAuthModal}>
                  {t("enter")}
                </Button>
              </>
            )}
          </Flex>
        </Flex>
      </StickyHeader>

      <Layout.Content>{children}</Layout.Content>

      {isChinaInstance && (
        <Layout.Footer>
          <Flex justify="center">
            <Typography.Text type="secondary">
              版权所有{" "}
              <Typography.Link href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                粤ICP备2026096023号
              </Typography.Link>
            </Typography.Text>
          </Flex>
        </Layout.Footer>
      )}
    </Layout>
  );
}

export default React.memo(PublicLayout);
